import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddWITHPRINTModal from '../../components/modals/addWithPrintModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter'; 
import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';






function VisitTransaction(props) {

  let { } = props;


  const { userData, api, refClass, classData, refTrainer, trainerData  } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const table = 'transaction';
  const title = 'New Visit';


  useEffect(() => {
    const fetchData = async () => {
      try {
        await refClass();
        await refTrainer();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const classOptions = classData.map(item => ({
    value: item.id,
    label: `${item.name} (${item.trainer?.name || 'No Trainer'})`,
    price: item.price,
    trainerId: item.trainerId,
  }));

  const trainerOptions = trainerData.map(item => ({
    value: item.id,
    label: item.name,
  
  }));


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', visitsId: null, type: "visit", fromDate: today, toDate: today });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [transaction, setTransaction] = useState({});    

  // idRow Change
  useEffect(() => {

    setTransaction(
      {
        createdBy: createdBy,
        accountId: idRow?.value || null,
        usd: idRow?.usd || 0,
        trainerId: idRow?.trainerId || null,
        classId: idRow?.classId || null,
        isOut: false,
        type: 'visit',
      }
    )
  }, [idRow]);



  const addModal = (type) => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }



  const resetForm = () => {
    setTransaction({});
  };


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }

    setTransaction((prevtransaction) => ({
      ...prevtransaction,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setTransaction((prevtransaction) => ({
      ...prevtransaction,
      [name]: selectedOption.value,
    }));
  };


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        visits: item.visits?.name,
        usd: item.usd,
      };

      transformedData.push(newItem);
    });

    return transformedData;
  };

  useEffect(() => {

    let updatedColumnDefs = [
      { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter, width: '15%' },
      { title: 'class', dataIndex: 'class', render: (e) => (e?.name), width: '15%' },
      { title: 'trainer', dataIndex: 'trainer', render: (e) => (e?.name), width: '15%' },
      { title: 'Net Price', dataIndex: 'usd', },

    ];


    if (filter.isActive === 'true') {
      updatedColumnDefs.push(
        {
          title: 'Edt',
          width: '5%',
          render: (_, record) => (
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
          ),
        },
        {
          title: 'Del',
          width: '5%',
          render: (_, record) => (
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
          ),
        }
      );
    } else {
      updatedColumnDefs.push({
        title: 'Rec',
        width: '5%',
        render: (_, record) => (
          <FcUndo size={20} style={{ cursor: 'pointer' }} onClick={() => recoverModal(record)} />
        ),
      });
    }


    setColumnDefs(updatedColumnDefs);

  }, [filter.isActive]);



  const formView = (
    <div style={{ userSelect: 'none' }}>

      <Row className="mb-3" style={{ marginTop: '2%' }}>
        {/* visits  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>visits<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            style={{ width: '100px' }}
            options={classOptions.filter(option => option.value !== null)}
            isSearchable={true}
            placeholder="Select"
            value={classOptions?.find(option => option.value === transaction.classId) || []}
            onChange={e => handleSelectChange(e, 'classId')}
            required
          />
        </Form.Group>

      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>
        {/* visits  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Trainer<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            style={{ width: '100px' }}
            options={trainerOptions.filter(option => option.value !== null)}
            isSearchable={true}
            placeholder="Select"
            value={trainerOptions?.find(option => option.value === transaction.trainerId) || []}
            onChange={e => handleSelectChange(e, 'trainerId')}
            required
          />
        </Form.Group>

      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>
        <Form.Group as={Col}>
          <Form.Label>USD:</Form.Label>
          <input type="text" name="usd" id="usd" className="form-control"
            value={transaction.usd}
            onChange={handleInputChange}></input>
        </Form.Group>
      </Row>





    </div >);





  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>

        <>
          <span className='table-footer footer-one'>Count: {numberFormatter(data?.summary?.visitCount, 2)}</span>
          <span className='table-footer footer-green'>Balance: {numberFormatter(data?.summary?.totalVisits, 2)}</span>
        </>


      </div>
    </div>

  );

  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <DatePicker setFilter={setFilter} filter={filter} />
            <AddButton addModal={addModal} />

          </div>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddWITHPRINTModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'small'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ transaction }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, transaction }}
          />


        </>
      }

    </div>
  )
}

export default VisitTransaction;
